import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faFileZipper } from '@fortawesome/free-solid-svg-icons';

//APP
import type { AnaliseAdicionada } from '../../../../../../types';
import { baixarKmlAnalise, baixarShapeAnalise } from '../../meta';

//COMPONENTS
import ButtonCustom from '../../../../../../../../../../../../../../Components/ButtonCustom';
import { Box } from '../../../../../../../../../../../../../../Components/CustomUi/box';

interface Props {
    analise: AnaliseAdicionada
    nomePropriedade?: string
    nomeTalhao?: string
    /** Fecha o popover após disparar o download. */
    aoBaixar?: () => void
}

/** Conteúdo do popover de download: escolha do formato do arquivo. */
export function BaixarArquivoAnalise({ analise, nomePropriedade, nomeTalhao, aoBaixar }: Props) {

    function baixarKml() {
        baixarKmlAnalise(analise, nomePropriedade, nomeTalhao)
        aoBaixar?.()
    }

    function baixarShape() {
        baixarShapeAnalise(analise, nomePropriedade, nomeTalhao)
        aoBaixar?.()
    }

    return (
        <Box>
            <ButtonCustom
                onClick={baixarKml}
                icon={<FontAwesomeIcon icon={faDownload} />}
            >
                Baixar KML
            </ButtonCustom>
            <ButtonCustom
                type='secondary'
                onClick={baixarShape}
                icon={<FontAwesomeIcon icon={faFileZipper} />}
            >
                Baixar Shape
            </ButtonCustom>
        </Box>
    )
}
